import ArticleLayout from '@/components/base/ArticleLayout';
import { allArticles } from '@/mocks/seoArticles';

export default function AlternativeItaobuyPage() {
  return <ArticleLayout data={allArticles['alternative-itaobuy']} />;
}